// ─── useAITracker.js ──────────────────────────────────────────────────────────
// Wraps callAI() to record usage to the ai_usage table automatically.
// Import as: import { useAITracker } from "./useAITracker";
//
// Usage (replace your current callAI imports):
//   const { callAI } = useAITracker(company, currentUser);
//   const result = await callAI({ system, messages, maxTokens: 1500, feature: "sar_draft" });
//
// feature values: "sar_draft" | "crypto_analysis" | "ai_assistant" |
//                 "tm_rule_suggest" | "kyc_review" | "unknown"

import { callAI as _callAI } from "./aiClient";

export function useAITracker(company, currentUser) {
  async function callAI({ system, messages, maxTokens = 1500, feature = "unknown" }) {
    const start = Date.now();
    let success = true;
    let result;
    try {
      result = await _callAI({ system, messages, maxTokens });
      return result;
    } catch (err) {
      success = false;
      throw err;
    } finally {
      if (company?.id) {
        const token = localStorage.getItem('amlguard_token');
        if (token) {
          Promise.resolve(
            fetch('/api/db/ai-usage', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
              body: JSON.stringify({
                company_id:  company.id,
                user_id:     currentUser?.id   || null,
                user_email:  currentUser?.email || null,
                feature,
                latency_ms:  Date.now() - start,
                success,
              }),
            })
          ).catch(() => {}); // never block on tracking
        }
      }
    }
  }
  return { callAI };
}